import React from 'react';

// BL-177 Step 2j (E): Settings > Sign-in & security.
// Honest by design: today the app has NO screen where a signed-in person changes their password or authenticator. Those happen at
// sign-in (first password, the emailed one-time code, the admin authenticator) and through "Can't sign in / Forgot password?" on the
// sign-in page. So this panel shows only what is true and what exists, and invents no control. When a real security screen is
// built, its switches belong here.
export default function SignInSecurityPanel({ userEmail = '' }) {
    return (
        <div className="flex flex-col gap-3 text-sm" data-testid="sign-in-security">
            {userEmail ? (
                <p>You are signed in as <strong data-testid="security-email">{userEmail}</strong>.</p>
            ) : null}
            <p data-testid="security-nothing-here">
                There is nothing to change here yet. Your password and your authenticator are set up when you first sign in, and the
                emailed one-time code is part of signing in.
            </p>
            <p>
                If you cannot sign in or you forgot your password, choose &quot;Can&apos;t sign in / Forgot password?&quot; on the sign-in
                page.
            </p>
        </div>
    );
}
